export const DEFAULT_CONFIG = {
  title: "Tag",
  maxLastUsedTagsCount: 3,
  allowNewTag: false,
  allowEditTag: false,
  allowDeleteTag: false,
};
